const c = {
  name: "HandsLove",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 37.5" style="enable-background:new 0 0 40 37.5;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M36.2,3.8C33.7,1.4,30.5,0,27,0c-2.5,0-4.9,0.7-7,2.1C14.9-1.2,8.2-0.5,3.8,3.8c-4.4,4.4-5,11.1-1.7,16.3
			c-0.5,1.4-0.2,3.1,0.9,4.2c0.8,0.8,1.8,1.2,2.8,1.2c0.1,0,0.2,0,0.3,0c-0.1,1.1,0.3,2.2,1.1,3.1c0.8,0.8,1.8,1.2,2.8,1.2
			c0.1,0,0.2,0,0.3,0c-0.1,1.1,0.3,2.2,1.1,3.1c0.8,0.8,1.8,1.2,2.8,1.2c0.3,0,0.7-0.1,1-0.1c0.1,0.9,0.4,1.8,1.1,2.5
			c0.8,0.8,1.8,1.2,2.8,1.2c1,0,2-0.4,2.8-1.2l2.1-2.1c0.3-0.3,0.5-0.6,0.7-1c0,0,0,0,0,0c1,0,2.1-0.4,2.8-1.2
			c0.9-0.8,1.2-2,1.1-3.1c0.1,0,0.2,0,0.3,0c1,0,2-0.4,2.8-1.2c0.8-0.8,1.2-1.8,1.2-2.8c0-0.1,0-0.2,0-0.3c0.1,0,0.2,0,0.3,0
			c1.1,0,2.1-0.4,2.8-1.2c0.8-0.8,1.2-1.8,1.2-2.8C41.3,15.6,40.8,8.4,36.2,3.8L36.2,3.8z M4.5,22.9c-0.8-0.8-0.8-2,0-2.8L6.6,18
			C7,17.6,7.5,17.4,8,17.4s1,0.2,1.4,0.6c0.8,0.8,0.8,2.1,0,2.8l-2.1,2.1C6.5,23.7,5.2,23.7,4.5,22.9L4.5,22.9z M8.7,27.2
			c-0.8-0.8-0.8-2,0-2.8l2.1-2.1c0.4-0.4,0.9-0.6,1.4-0.6c0.5,0,1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.4c0,0.5-0.2,1-0.6,1.4
			l-2.1,2.1C10.7,27.9,9.5,27.9,8.7,27.2L8.7,27.2z M12.9,31.4c-0.8-0.8-0.8-2,0-2.8l2.1-2.1c0.4-0.4,0.9-0.6,1.4-0.6
			c0.5,0,1,0.2,1.4,0.6c0.8,0.8,0.8,2,0,2.8l-1.4,1.4l-0.7,0.7C15,32.2,13.7,32.2,12.9,31.4L12.9,31.4z M22.8,32.8l-2.1,2.1
			c-0.8,0.8-2.1,0.8-2.8,0c-0.4-0.4-0.6-0.9-0.6-1.4c0-0.5,0.2-1,0.6-1.4l1.4-1.4L20,30c0.4-0.4,0.9-0.6,1.4-0.6
			c0.5,0,1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.4S23.2,32.4,22.8,32.8z M34.8,22.2c-0.7,0.8-2.1,0.8-2.8,0l-6.4-6.4l-1.4,1.4l4.2,4.2
			l2.1,2.1c0.4,0.4,0.6,0.9,0.6,1.4c0,0.5-0.2,1-0.6,1.4c-0.8,0.8-2,0.8-2.8,0l-2.1-2.1l-4.2-4.2L20,21.5l4.2,4.2l2.1,2.1
			c0.8,0.8,0.8,2,0,2.8c-0.3,0.3-0.6,0.4-1,0.5c-0.1-1-0.4-1.9-1.2-2.7c-1-1-2.5-1.4-3.8-1c-0.1-0.9-0.4-1.8-1.1-2.5
			c-0.8-0.8-1.8-1.2-2.8-1.2c-0.1,0-0.2,0-0.3,0c0-0.1,0-0.2,0-0.3c0-1.1-0.4-2.1-1.2-2.8c-0.8-0.9-2-1.2-3.1-1.1
			c0.1-1.1-0.3-2.2-1.1-3.1c-1.6-1.6-4.1-1.6-5.7,0l-1.8,1.8C1,14.1,1.7,8.8,5.2,5.2C8.8,1.7,14.1,1,18.3,3.4
			c-0.2,0.2-0.3,0.3-0.5,0.4l-5.6,5.6l-0.7,0.8c-0.8,0.8-0.8,2,0,2.8l0.7,0.7c0.8,0.8,1.8,1.2,2.8,1.2s2.1-0.4,2.8-1.2l4.2-4.2
			c0.8-0.8,2.1-0.8,2.8,0l9.9,9.9c0.3,0.3,0.5,0.7,0.6,1.1c0,0,0,0.1,0,0.2C35.5,21.3,35.3,21.8,34.8,22.2L34.8,22.2z M36.6,18.4
			c-0.1-0.1-0.2-0.3-0.4-0.4l-9.9-9.9c-0.8-0.8-1.8-1.2-2.8-1.2s-2,0.4-2.8,1.2l-4.2,4.2c-0.4,0.4-0.9,0.6-1.4,0.6
			c-0.5,0-1-0.2-1.4-0.6l-0.7-0.7l6.3-6.3c0.4-0.5,0.9-0.8,1.4-1.2C22.4,2.7,24.7,2,27,2c2.9,0,5.7,1.1,7.8,3.2
			C38.3,8.8,39,14.1,36.6,18.4L36.6,18.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as HandsLove
};
